import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/saleHistorical/${dossierId}/economicPlan`, method: 'GET', token: token })
}
